import { Link } from 'react-router'
import { R } from './parts'

export function Strategy() {
  return (
    <>
      <h2>Know what your side needs</h2>
      <p>
        The whole game is one vote, so start from what each side wants out of it. The village needs a Werewolf
        to die. The Werewolves need every wolf to survive. The <R id="tanner" /> needs to die himself, and the{' '}
        <R id="minion" /> is happy to die for the wolves. Dying is not losing: a villager who is voted out
        wins with the village if a wolf goes down in the same vote. The exact conditions are in{' '}
        <Link to="/rules/">the rules</Link>.
      </p>
      <p>
        And remember which side you are on. Your team is decided by the card in front of you when the night
        ends, not by the card you were dealt. If the <R id="robber" /> took your Werewolf, you are a villager
        now, and the best thing you can do is say so.
      </p>

      <h2>The first minute</h2>
      <ul>
        <li>
          <strong>Talk early.</strong> Silence helps the wolves: every quiet minute is a minute they do not
          have to lie in.
        </li>
        <li>
          <strong>Claim something.</strong> In the day the Roles button becomes "Claim a role". The claim sits
          on your card for everyone to see, and a role turns red when more players claim it than the deck has
          cards of it. A player with no claim is the easiest vote at the table.
        </li>
        <li>
          <strong>Say what you did, and to whom.</strong> "I am the Seer" is a claim. "I am the Seer and I saw
          that Dana is the Troublemaker" is a claim somebody can check.
        </li>
      </ul>

      <h2>Playing for the village</h2>
      <ul>
        <li>
          <strong>Build the night in order.</strong> Put the claims in{' '}
          <Link to="/guides/night-order/">wake order</Link> and replay them: who looked, who moved what, what
          the last mover left behind. Two stories that cannot both be true are where the wolf is.
        </li>
        <li>
          <strong>Trust facts that two players share.</strong> Two <R id="mason">Masons</R>, a Robber and the
          player he robbed, a <R id="thing" /> and the neighbour it tapped: each half confirms the other, and
          a liar can only supply one.
        </li>
        <li>
          <strong>Count the deck.</strong> The deck is one tap away all game. Three cards lie in the center,
          so three roles have no player. A claim of a role that someone saw in the center is a lie.
        </li>
        <li>
          <strong>Hold something back.</strong> Give most of what you know and keep one detail. When a second
          player claims your role, ask them for the detail.
        </li>
        <li>
          <strong>Vote in a circle when no wolf is at the table.</strong> If nobody gets more than one vote,
          nobody dies, and with both wolves in the center that is how the village wins. Agree on it out loud:
          everyone votes for the player on their left.
        </li>
      </ul>

      <h2>Playing as a Werewolf</h2>
      <ul>
        <li>
          <strong>Have a role ready before the sun rises.</strong> The safest claim is a card that lies in the
          center: a lone wolf may look at one, and should. A <R id="villager" /> claim is safe only while the
          deck has more Villager cards than claimants.
        </li>
        <li>
          <strong>Claim a night that fits the others.</strong> A fake Robber has to name a victim, who will
          say what they were dealt. A fake Seer has to name a card. Pick details nobody at the table can
          contradict.
        </li>
        <li>
          <strong>Do not defend your partner first.</strong> Let a villager do it, then agree.
        </li>
        <li>
          <strong>Believe the Troublemaker, sometimes.</strong> If she says she swapped your card, you may be
          a villager now, with a wolf card sitting in front of somebody else. Work out which before you vote.
        </li>
        <li>
          <strong>Use the Minion and the Tanner.</strong> A Minion who draws the vote wins you the game. A
          Tanner who draws it loses it for you, so learn to tell them apart.
        </li>
      </ul>

      <h2>Playing alone</h2>
      <p>
        The Tanner, the <R id="mortician" />, the <R id="blob" />, the <R id="assassin" /> and the{' '}
        <R id="syntheticAlien" /> win or lose by themselves. Nobody at the table shares your goal, which frees
        you to say anything. The Tanner’s craft is to be a little too easy to catch: tell a story with one
        hole in it, and let a villager find the hole.
      </p>

      <h2>Mistakes everyone makes once</h2>
      <ul>
        <li>Voting for the first player who was accused, before the accuser has been asked anything.</li>
        <li>
          Forgetting that cards moved. "I am the Seer" is about the deal; the vote is about the morning.
        </li>
        <li>Believing a claim because it is detailed. Wolves have had the whole night to prepare details.</li>
        <li>
          Killing the player who seems to want it. That is the Tanner, or the Minion, and either way you lose.
        </li>
        <li>Skipping to the vote while a claim is still unanswered.</li>
      </ul>

      <h2>Practise against the bots</h2>
      <p>
        You do not need a full table to try any of this. Create a table, add bots to the empty seats and play:
        they claim roles, lie when they are wolves, answer what you ask in the chat and vote. See{' '}
        <Link to="/guides/bots/">how the bots play</Link>, and{' '}
        <Link to="/guides/decks/">which deck to start with</Link>.
      </p>
    </>
  )
}
